export default function Filters({handleFilterChange}) {
    return (
        <div className="flex items-center justify-between mb-12">
            <h4 className="mt-2 text-xl font-bold">Book List</h4>

            <div className="flex items-center space-x-4">
                <button 
                    onClick={() => handleFilterChange("All")}
                    className="filter-btn active-filter"
                    id="lws-filterAll"
                >
                    All
                </button>
                <button
                    onClick={() => handleFilterChange("Featured")}
                    className="filter-btn"
                    id="lws-filterFeatured"
                >
                    Featured
                </button>
            </div>
        </div>
    );
}